import { useQuery, useQueryClient } from '@tanstack/react-query';
import gql from 'graphql-tag';
import useGraphQLPaging from 'hooks/graphql/useGraphQLPaging/useGraphQLPaging';
import useReactQueryBaseKey from 'hooks/react-query/useReactQueryBaseKey/useReactQueryBaseKey';

export const ACTIVE_MEMBER_COUNT_QUERY = gql`
  query ActiveMemberCount($first: Int, $after: String) {
    members(first: $first, after: $after, filter: { archivedOn: { isNull: true }, deletedOn: { isNull: true } }) {
      id
      cursor
    }
  }
`;

function useActiveMemberCountQueryKey() {
  const baseQueryKey = useReactQueryBaseKey();

  return [...baseQueryKey, 'activeMemberCount'];
}

function useActiveMemberCountQueryFn() {
  const pageAll = useGraphQLPaging();
  return () => pageAll({ document: ACTIVE_MEMBER_COUNT_QUERY }, 'members', 500).then((m) => m.length);
}

export function useFetchActiveMemberCount() {
  const queryClient = useQueryClient();
  const queryKey = useActiveMemberCountQueryKey();
  const queryFn = useActiveMemberCountQueryFn();

  return () => queryClient.fetchQuery({ queryKey, queryFn, staleTime: 0, gcTime: 0 });
}

export function useActiveMemberCountQuery() {
  const queryKey = useActiveMemberCountQueryKey();
  const queryFn = useActiveMemberCountQueryFn();

  return useQuery({ queryKey, queryFn, staleTime: 0, gcTime: 0 });
}
